import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { useSnackbar } from "notistack";
import shippingFeeApi from "../../../apis/shippingFeeApi";
import styles from "./FastShippingFeeConfig.module.scss";

export interface FastShippingFeeConfigProps {
  partnerId?: string;
}

const FastShippingFeeConfig: React.FC<FastShippingFeeConfigProps> = ({ partnerId: propPartnerId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [fee, setFee] = useState<number>(10000);
  const [inputVal, setInputVal] = useState<string>("10000");
  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);

  const getPartnerId = (): string => {
    if (propPartnerId) return propPartnerId;
    const partnerDataStr = localStorage.getItem("partnerData");
    if (partnerDataStr) {
      try {
        const p = JSON.parse(partnerDataStr);
        if (p.id || p.partnerId) return p.id || p.partnerId;
      } catch (e) {}
    }
    return process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
  };

  const partnerId = getPartnerId();

  const fetchCurrentFee = async () => {
    setLoading(true);
    try {
      const res = await shippingFeeApi.getFastShippingFee({ partnerId });
      if (res?.data?.code === 0 && res?.data?.data) {
        const currentFee = res.data.data.fee ?? 10000;
        setFee(currentFee);
        setInputVal(String(currentFee));
      }
    } catch (error) {
      console.error("fetch fast shipping fee error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrentFee();
  }, [partnerId]);

  const handleSave = async () => {
    const num = parseFloat(inputVal);
    if (isNaN(num) || num < 0) {
      enqueueSnackbar("Vui lòng nhập số tiền hợp lệ (>= 0đ)", { variant: "warning" });
      return;
    }

    setSaving(true);
    try {
      const res = await shippingFeeApi.updateFastShippingFee({ partnerId, fee: num });
      if (res?.data?.code === 0) {
        setFee(num);
        enqueueSnackbar(`Đã cập nhật phụ phí hỏa tốc thành +${num.toLocaleString("vi")} VNĐ!`, { variant: "success" });
      } else {
        enqueueSnackbar(res?.data?.message || "Lỗi khi cập nhật phí hỏa tốc", { variant: "error" });
      }
    } catch (error: any) {
      console.error("update fast shipping fee error:", error);
      enqueueSnackbar("Lỗi cập nhật: " + (error?.response?.data?.message || error.message), { variant: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.title}>
          <span>⚡ Cấu hình phụ phí giao Hỏa tốc</span>
        </div>
        <div className={styles.badge}>
          Đang áp dụng: +{fee.toLocaleString("vi")} đ
        </div>
      </div>
      <div className={styles.desc}>
        Mức phụ phí này sẽ được cộng thêm vào phí ship tiết kiệm khi khách hàng hoặc admin chọn hình thức giao <strong>Hỏa tốc</strong>. Bạn có thể tùy chỉnh lại bất kỳ lúc nào.
      </div>
      <div className={styles.formRow}>
        <div className={styles.inputWrap}>
          <TextField
            size="small"
            type="number"
            label="Phí hỏa tốc cộng thêm"
            value={inputVal}
            onChange={(e) => setInputVal(e.target.value)}
            disabled={loading || saving}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">VNĐ</InputAdornment>,
            }}
          />
        </div>
        <Button
          variant="contained"
          className={styles.saveBtn}
          onClick={handleSave}
          disabled={loading || saving}
        >
          {saving ? "Đang lưu..." : "Lưu cấu hình"}
        </Button>
      </div>
    </div>
  );
};

export default FastShippingFeeConfig;

